var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__edit-tools_2_",
    width: 16,
    height: 16,
    "data-name": "edit-tools (2)",
    viewBox: "0 0 16.298 16.211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a4b9dd",
    id: "prefix__Path_587",
    d: "M15.831 28.215a.427.427 0 0 0-.427.427v3.793a1.283 1.283 0 0 1-1.282 1.282H2.136a1.283 1.283 0 0 1-1.282-1.281V21.3a1.283 1.283 0 0 1 1.282-1.282h3.793a.427.427 0 0 0 0-.854H2.136A2.138 2.138 0 0 0 0 21.3v11.136a2.138 2.138 0 0 0 2.136 2.136h11.986a2.138 2.138 0 0 0 2.136-2.136v-3.793a.427.427 0 0 0-.427-.428zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 587",
    transform: "translate(0 -18.361)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4b9dd",
    id: "prefix__Path_588",
    d: "M156.367 38.566l6.237-6.237 2.012 2.012-6.237 6.237zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 588",
    transform: "translate(-149.688 -30.959)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4b9dd",
    id: "prefix__Path_589",
    d: "M132.543 199.442l2.223-.616-1.607-1.607zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 589",
    transform: "translate(-126.881 -188.806)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4b9dd",
    id: "prefix__Path_590",
    d: "M318.491.581a1.069 1.069 0 0 0-1.51 0l-.453.453 2.012 2.012.453-.453a1.069 1.069 0 0 0 0-1.51zm0 0",
    className: "prefix__cls-1",
    "data-name": "Path 590",
    transform: "translate(-303.006 -.269)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableEditIcon);
export default __webpack_public_path__ + "static/media/TableEditIcon.1be9ca0dbc01c113661b72bc907a4767.svg";
export { ForwardRef as ReactComponent };